export default __webpack_public_path__ + "static/media/April2013.ea670924.png";